module.exports = __webpack_public_path__ + "img/img03.7fa9b299.png";